goog.provide('el8.appchart.refpanel.referrals');

goog.require('el8.uiwidget.Component');
goog.require('el8.ptdata.base');
goog.require('el8.appservice.notifier');
goog.require('el8.appchart.metrics');
goog.require('el8.appchart.mgr.notes');
goog.require('el8.appchart.dialog.referralHistory');
goog.require('el8.template.appchart.refpanel.referrals');

el8.appchart.refpanel.referrals = (function() {

    var reportOnFirstLoad = el8.appchart.metrics.getChartLoadCallback('referrals');

    return new el8.uiwidget.Component({
        dataRenderers: [
            {
                entitySet: el8.ptdata.allSignedReferralOrders,
                listenFn: function() {

                    var allReferrals = el8.ptdata.allSignedReferralOrders.latestOrdersBySpecialty({
                        includeOnHold: false
                    });

                    $("#referral-summary").replaceWith($(
                        el8.template.appchart.refpanel.referrals.summary({
                            hasActions: !el8Globals.TEASE,
                            items: allReferrals.map(el8.model.toSoyMapFn)
                        })
                    ));

                    if (allReferrals.length) {
                        $('.le-empty-entry', '#consultation-history-list').remove();
                    }

                    $('#referral-summary').on('click', '.add-to-note-trigger',  function(event) {
                        event.preventDefault();
                        var id = $(this).attr('orderId')*1;
                        var text = el8.ptdata.allSignedReferralOrders.getById( id ).getNoteSummary();
                        el8.appservice.notifier.notify('Referred Specialist added to current note.');
                        el8.appchart.mgr.notes.addText(text, 'data');
                    });

                    // Activate the referral history link.
                    $('#referral-summary').on('click', '.referral-history-trigger',  function(event) {
                        event.preventDefault();
                        var specialtyId = $(this).attr('specialtyId')*1 || null;
                        el8.appchart.dialog.referralHistory.show(
                             { container : $('#referral-history-ui'),
                               referralOrders : el8.ptdata.allSignedReferralOrders.bySpecialtyId(specialtyId) }
                        );
                    });

                    reportOnFirstLoad();

                }
            }
        ]
    });

})();